/**
 * SPA navigation primitives shared by every screen (the app has no router): the pathname hook
 * that re-renders on popstate and the programmatic pushState navigation every screen used to
 * define privately. Extracted so the app shell, the dashboard and the command palette navigate
 * through one implementation.
 */

import { useEffect, useState } from 'react';

/**
 * Tracks the current pathname; the SPA has no router, a plain hook is enough for M0.3.
 */
export function usePathname(): string {
  const [pathname, setPathname] = useState((): string => window.location.pathname);

  useEffect(() => {
    function onPopState(): void {
      setPathname(window.location.pathname);
    }
    window.addEventListener('popstate', onPopState);
    return () => {
      window.removeEventListener('popstate', onPopState);
    };
  }, []);

  return pathname;
}

/**
 * Navigates the SPA: pushState plus the popstate event {@link usePathname} listens to.
 */
export function navigateTo(path: string): void {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}
